import SvgIcon from '@home/components/SvgIcon';
import { NO_DATE } from '@op/constants';
import ChannelLabel from '@op/components/ChannelLabel';
import { formatThousandthValue, percentageFormat } from '@op/utils/value';
import { getShowCount } from '@op/utils';
import React, { useMemo } from 'react';
import { useIntl } from 'umi';

type SteamItemType = {
  review: number;
  score: number;
  name?: string;
};
interface IReviewsProgressProps {
  title: string;
  data: SteamItemType;
}
export default function ReviewsProgress({
  title,
  data,
}: IReviewsProgressProps) {
  const { formatMessage } = useIntl();

  const { review, score, goodRatio, badRatio, text } = useMemo(() => {
    const { review, score, name } = data || {};
    return {
      review,
      score,
      goodRatio: (score * 100),
      badRatio: review === 0 ? 0 : (100 - score * 100),
      text: name,
    };
  }, [data]);

  // 计算好评值\差评值 使用舆情格式化方法
  const goodReviews = Math.ceil(review * score);
  const negativeReviews = review - goodReviews;
  const goodReviewsValue = isNaN(goodReviews) ? '-' : getShowCount(goodReviews);
  const negativeReviewsValue = isNaN(negativeReviews) ? '-' : getShowCount(negativeReviews);

  return (
    <div className="positive-mixed">
      <div className="positive-mixed-title">
        <ChannelLabel channel_name="steam" showText={false}></ChannelLabel>
        {/* <SvgIcon type="steam-icon" className="positive-mixed-icon" /> */}
        <span className="positive-mixed-title-text">
          {formatMessage({ id: title })}
        </span>
      </div>
      <div className= "dbh-studio-positive-mixed">
        <div className="positive-mixed-desc">
          {formatMessage({ id: text || NO_DATE.EMPTY })}
        </div>
        <div className="positive-mixed-num">
          {formatThousandthValue(review)} {formatMessage({ id: 'Reviews-1' })}
        </div>
      </div>
      <div className="positive-mixed-box">
        <div className="positive-mixed-box-item">
          <SvgIcon type="good-icon" className="positive-mixed-box-icon" />
          <div className="positive-mixed-box-progress">
            <div
              className="positive-mixed-box-progress-inner"
              style={{ width: `${goodRatio}%` }}
            ></div>
          </div>
          <div className='positive-mixed-box-progress-data'>{`${goodReviewsValue}(${percentageFormat(
            goodRatio,
            '-',
            0,
          )})`}</div>
        </div>
        <div className="positive-mixed-box-item positive-mixed-box-item-nogood">
          <SvgIcon type="no-good-icon" className="positive-mixed-box-icon" />
          <div className="positive-mixed-box-progress">
            <div
              className="positive-mixed-box-progress-inner"
              style={{ width: `${badRatio}%` }}
            ></div>
          </div>
          <div className='positive-mixed-box-progress-data'>{`${negativeReviewsValue}(${percentageFormat(
            badRatio,
            '-',
            0,
          )})`}</div>
        </div>
      </div>
    </div>
  );
}
